export const NAVIGATION_ID_KEY = 'navigation_id';
